import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "antd";
import { Link } from "react-router-dom";
import ConfirmatoryModal from "../ConfirmatoryModal";
import { deleteRedirection, archiveRedirection, getModalData } from "../../Functions/myfunctions"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const RedirectionsTable = (props) => {
    const [gridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '' });
    const [urlLink, setUrlLink] = useState();


    useEffect(() => {
        loadData();
    }, [props.selected.key])

    const loadData = async () => {
        setLoading(true);

        axios.post(process.env.REACT_APP_BASE_URL + "/api/redirections/list/" + props.selected.key + "/?code=" + process.env.REACT_APP_API_KEY, {
            "sessionToken": sessionStorage.getItem("sessionToken")
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log(res);
            console.log(res.data);
            setGridData(res.data);
        }).catch((error) => {
            if (error.response.data === "Access denied!") {
                sessionStorage.clear();
                window.location = "/";
            }
        });

        setLoading(false);
    }


    const confirmationfunction = (event) => {
        event.preventDefault();
        if (actionName.action == "delete") {
            deleteRedirection(urlLink, "reload");
        }

        if (actionName.action === "archive") {
            archiveRedirection(urlLink);
        }
        setModalShow(false);
    }

    const modifiedData = gridData.map(({ body, ...item }) => ({
        ...item,
        key: item.RowId,
    }));

    const columns = [
        {
            title: "Gyári szám",
            dataIndex: "SerialNumber",
            align: "center",
            key: "SerialNumber",
        },
        {
            title: "Publikus Url",
            dataIndex: "PublicUrl",
            align: "center",
            render: (text) => <div className="div-custom-url"><Link className="custom-url" target="_blank" to={text}>{text}</Link></div>,
            key: "PublicUrl",
        },
        {
            title: "Privát Url",
            dataIndex: "PrivateUrl",
            align: "center",
            render: (text) => <div className="div-custom-url"><Link className="custom-url" target="_blank" to={text}>{text}</Link></div>,
            key: "PrivateUrl",
        },
        {
            title: "Partner",
            dataIndex: "Partner",
            align: "center",
            key: "Partner",
        },
        {
            title: "Megjegyzés",
            dataIndex: "Comment",
            align: "center",
            key: "Comment",
        },
        {
            title: "Státusz",
            dataIndex: "Active",
            align: "center",
            key: "Active",
            render: (text) => <p> {text === "1" ? "Aktív" : "Inaktív"} </p>
        },
        {
            title: "Műveletek",
            dataIndex: "RowId",
            align: "center",
            render: (text, record) => <div className="custom-actions">
                <OverlayTrigger
                    overlay={
                        <Tooltip id={'tooltip' + text}>
                            <strong>Szerkesztés</strong>
                        </Tooltip>
                    }
                >
                    <Link to={"/modificationredirection/" + text} >
                        <div alt="edit" className="svgicon edit"></div>
                    </Link>
                </OverlayTrigger>
                <OverlayTrigger
                    overlay={
                        <Tooltip id={'tooltip' + text}>
                            <strong>Törlés</strong>
                        </Tooltip>
                    }
                >
                    <Link onClick={() => getModalData({ name: 'Kívánja a törlést végrehajtani?', action: 'delete' }, text, modalShow, setActionName, setUrlLink, setModalShow)}>
                        <div alt="delete" className="svgicon delete"></div>
                    </Link>
                </OverlayTrigger>
                <OverlayTrigger
                    overlay={
                        <Tooltip id={'tooltip' + text}>
                            <strong> {record.Active === "1" ? "Archiválás" : "Aktiválás"}</strong>
                        </Tooltip>
                    }
                >
                    {record.Active === "1" ? <Link onClick={() => getModalData({ name: 'Kívánja az archiválást végrehajtani?', action: 'archive' }, text, modalShow, setActionName, setUrlLink, setModalShow)} >
                        <div alt="archive" className="svgicon archive"></div>
                    </Link> : <Link onClick={() => getModalData({ name: 'Kívánja az aktiválást végrehajtani?', action: 'archive' }, text, modalShow, setActionName, setUrlLink, setModalShow)} >
                        <div alt="archive" className="svgicon archive"></div>
                    </Link>}
                </OverlayTrigger>
            </div>,
            key: "RowId",
        }
    ].filter(item => !item.hidden);


    return (
        <div>
            <Table columns={columns} dataSource={modifiedData} bordered loading={loading} id="redirectionsTable" />
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    )
};

export default RedirectionsTable;